import React from "react";
import { Box } from "@mui/material";

const DiamondPremiumImg = (props) => {
  const { marginRight, height } = props;

  return (
    <Box
      className="add-new"
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      gap={1}
      sx={{
        mr: marginRight || 2,
      }}
    >
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/premium.svg`}
        alt="Premium"
        sx={{
          maxHeight: height || 40,
          width: "auto",
          objectFit: "contain",
        }}
      />
    </Box>
  );
};

export default DiamondPremiumImg;
